export default "__VITE_ASSET__DHan$PDj__"